import { ReactNode } from 'react'
import { Card } from 'react-daisyui'

interface PortalStandardComponentProps {
  title: string
  description?: string
  actions?: ReactNode
  children: ReactNode
  noCard?: boolean
  containerClass?: string
}

export default function PortalStandardComponent({
  title,
  description,
  actions,
  children,
  noCard,
  containerClass,
}: PortalStandardComponentProps) {
  return (
    <div className={'container px-3 md:px-5 mx-auto py-5' + (containerClass || '')}>
      <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-[1.75rem]'>
        <div className='flex flex-col gap-1 min-w-0'>
          <h1 className='text-3xl md:text-4xl font-serif font-light mt-5'>{title}</h1>
          {description && <p className='whitespace-pre-line break-words opacity-70'>{description}</p>}
        </div>
        {actions && (
          <div className='flex items-center gap-2 md:overflow-x-visible overflow-x-auto flex-shrink-0'>
            {actions}
          </div>
        )}
      </div>
      {!noCard && (
        <Card className='bg-neutral border border-[var(--portal-border)]'>
          <Card.Body className='p-3 md:p-8'>{children}</Card.Body>
        </Card>
      )}
      {noCard && children}
    </div>
  )
}
